var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._user ? _c('v-fade-transition', [_vm.$vuetify.breakpoint.mdAndUp ? _c('v-dialog', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.user,
      expression: "user"
    }],
    attrs: {
      "max-width": "360",
      "content-class": "rounded-xl"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "fixed": "",
            "bottom": "",
            "right": "",
            "fab": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-qrcode")])], 1)];
      }
    }], null, false, 3437668234)
  }, [_c('user-qrcode-card', _vm._b({}, 'user-qrcode-card', {
    user: _vm.user
  }, false))], 1) : _c('v-bottom-sheet', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.user,
      expression: "user"
    }],
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var attrs = _ref2.attrs,
          on = _ref2.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "fixed": "",
            "bottom": "",
            "right": "",
            "fab": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-qrcode")])], 1)];
      }
    }], null, false, 3437668234)
  }, [_c('user-qrcode-card', _vm._b({
    staticClass: "rounded-t-xl"
  }, 'user-qrcode-card', {
    user: _vm.user
  }, false))], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }